import React from 'react'
import NextBoxDiaryPage from './NextBoxDiaryPage'
import '../styles/index.scss'

function NextBoxDiaryContainer() {
    return (
        <div className='NextBoxDiaryContainer'>
            <NextBoxDiaryPage />
        </div>
    )
}

export default NextBoxDiaryContainer